// chart/theme.js
//
// Resolve theme tokens and shared chart styling values.

const THEME_TOKENS = {
  PRIMARY_COLOR: '--gv-primary',
  SECONDARY_COLOR: '--gv-secondary',
  TERTIARY_YELLOW_COLOR: '--gv-tertiary-yellow',
}

// Resolve token to CSS variable value.
export function resolveColor(value) {
  const cssVar = THEME_TOKENS[value]

  if (!cssVar) return value

  return getComputedStyle(document.documentElement)
    .getPropertyValue(cssVar)
    .trim()
}

// Resolve dataset colors.
export function resolveDatasetColors(datasets) {
  datasets.forEach((dataset) => {
    if (typeof dataset.borderColor === 'string') {
      dataset.borderColor = resolveColor(dataset.borderColor)
    }

    if (typeof dataset.backgroundColor === 'string') {
      dataset.backgroundColor = resolveColor(dataset.backgroundColor)
    }

    if (Array.isArray(dataset.backgroundColor)) {
      dataset.backgroundColor =
        dataset.backgroundColor.map(resolveColor)
    }
  })
}

// Shared font family.
export function fontFamily() {
  return getComputedStyle(document.body).fontFamily
}
